import type { TypedClient } from '@platform/openapi';
import { usePerformance } from '../dashboard/performance.ts';
import { TrendCard } from '../dashboard/TrendCard.tsx';
import type { ReportPeriod } from '../report-period.ts';
import { usePageContext } from '../usePageContext.ts';
import { QueryView } from '../QueryView.tsx';
import { StageTiles } from './StageTiles.tsx';
import {
  ORDER_STAGE_TILES,
  useStatisticsFormat,
  useStatisticsReport,
  type OrdersReport,
} from './statistics.ts';
import styles from './Statistics.module.css';

const DAILY = 'day';

const OrderFigures = ({ report }: { report: OrdersReport }) => {
  const format = useStatisticsFormat(report.currency);
  return (
    <StageTiles
      stages={report.stages}
      order={ORDER_STAGE_TILES}
      labelPrefix="statistics.orders_"
      format={format}
      loading={false}
    />
  );
};

export const OrderStatistics = ({ api, period }: { api: TypedClient; period: ReportPeriod }) => {
  const { t } = usePageContext();
  const query = useStatisticsReport('orders', period, {}, () =>
    api.get('/admin/statistics/orders', { query: period }),
  );
  const series = usePerformance(api, period, DAILY, null);
  return (
    <div className={styles['stack']}>
      <QueryView query={query} label={t('statistics.tab_orders')}>
        {(report) => <OrderFigures report={report} />}
      </QueryView>
      <TrendCard report={series.data} loading={series.isPending} />
    </div>
  );
};
